import { useTheme } from '@/context/ThemeContext';

export default function ThemeToggle() {
  const { mode, toggleMode } = useTheme();

  return (
    <button
      onClick={toggleMode}
      className="text-dj-silver hover:text-dj-blue transition-colors p-2"
      aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {mode === 'dark' ? (
        <i className="fa-solid fa-sun text-xl" />
      ) : (
        <i className="fa-solid fa-moon text-xl" />
      )}
    </button>
  );
}
